import React from "react";

// import {TransactionContext} from "../../../../../context";
// import {CustomBadges, TableLoading, TableNullData} from "../../../../../components";

import "./index.scss";
import {
  CustomButton2,
  TableNullData,
  UserInformation,
} from "../../../../../../components";
import utils from "../../../../../../utils";
import Context from "../../../../../../context";
import { useTranslation } from "react-i18next";
import convertNumberToPrice from "../../../../../../utils/convertNumberToPrice";
import convertGregorianToJalali from "../../../../../../utils/convertGregorianToJalali";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {
  const { showModal, requestParentTransaction } = React.useContext(
    Context.ParentTransactionScreen
  );
  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = data?.data?.result?.docs;

  function onClickInfo() {
    setOpenInfoModal(!openInfoModal);
  }

  function onClickRow(index: number) {
    // setSelectedUserId(index);
    // setShowModal("SHOW");
  }

  const { t } = useTranslation();

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="find-transaction-body-container">
        {docs?.map((debt: any, index: number) => {
          let payerInfo: any = {};
          payerInfo = debt?.payerId;
          return (
            <tr
              key={`files-tr-${index}`}
              onClick={() => onClickRow(debt?.debtId?._id)}
            >
              <td onClick={onClickInfo}>
                <div className="table-index-number">
                  {requestParentTransaction.page === 1
                    ? index + 1
                    : (requestParentTransaction.page - 1) * 10 + index + 1}
                </div>
              </td>
              <td onClick={onClickInfo}>
                <UserInformation
                  //avatar={transaction?.driver?.avatar}
                  name={debt?.parent?.firstName + " " + debt?.parent?.lastName}
                  //lastName={transaction?.payerType}
                  phoneNumber={debt?.parent?.phoneNumber}
                  hideAvatar
                />
              </td>
              <td onClick={onClickInfo}>
                <UserInformation
                  avatar={debt?.student?.avatar}
                  name={
                    debt?.student?.firstName + " " + debt?.student?.lastName
                  }
                />
              </td>
              <td onClick={onClickInfo}>
                <UserInformation
                  avatar={debt?.driver?.avatar}
                  name={debt?.driver?.firstName + " " + debt?.driver?.lastName}
                  phoneNumber={debt?.driver?.phoneNumber}
                />
              </td>
              <td onClick={onClickInfo}>
                {convertNumberToPrice(debt?.amount)} {"تومان"}
              </td>
              <td onClick={onClickInfo}>
                {convertGregorianToJalali({
                  date: debt?.updatedAt,
                  format: "hh:mm  jYYYY/jMM/jDD ",
                })}
              </td>
              <td onClick={onClickInfo} className="table-text">
                {t(debt?.payerOriginType)}
              </td>
              <td onClick={onClickInfo} className="table-text">
                {debt?.isOnline &&
                  debt?.payerType === "PASSENGER" &&
                  "اپ اولیا"}
                {debt?.isOnline &&
                  debt?.payerType === "DRIVER" &&
                  "اپ راننده"}
                {!debt?.isOnline && "وب"}
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
};

export default Body;
